export interface MccCode {
	code: string
	description: string
}

export const stripeMccCodes: MccCode[] = [
	{code: "0742", description: "Veterinary Services"},
	{code: "0763", description: "Agricultural Cooperatives"},
	{code: "0780", description: "Landscaping and Horticultural Services"},
	{code: "1520", description: "General Contractors - Residential and Commercial"},
	{code: "1711", description: "Heating, Plumbing, and Air Conditioning Contractors"},
	{code: "1731", description: "Electrical Contractors"},
	{code: "1740", description: "Masonry, Stonework, Tile Setting, Plastering and Insulation Contractors"},
	{code: "1750", description: "Carpentry Contractors"},
	{code: "1761", description: "Roofing, Siding, and Sheet Metal Work Contractors"},
	{code: "1771", description: "Concrete Work Contractors"},
	{code: "1799", description: "Special Trade Contractors - Not Elsewhere Classified"},
	{code: "2741", description: "Miscellaneous Publishing and Printing"},
	{code: "2791", description: "Typesetting, Platemaking, and Related Services"},
	{code: "2842", description: "Specialty Cleaning, Polishing, and Sanitation Preparations"},
	{code: "4011", description: "Railroads"},
	{code: "4111", description: "Local and Suburban Commuter Passenger Transportation"},
	{code: "4112", description: "Passenger Railways"},
	{code: "4119", description: "Ambulance Services"},
	{code: "4121", description: "Taxicabs and Limousines"},
	{code: "4131", description: "Bus Lines"},
	{code: "4214", description: "Motor Freight Carriers and Trucking"},
	{code: "4215", description: "Courier Services - Air and Ground"},
	{code: "4225", description: "Public Warehousing and Storage"},
	{code: "4411", description: "Steamship and Cruise Lines"},
	{code: "4457", description: "Boat Rentals and Leasing"},
	{code: "4468", description: "Marinas, Marine Service, and Supplies"},
	{code: "4511", description: "Airlines and Air Carriers"},
	{code: "4582", description: "Airports, Flying Fields, and Airport Terminals"},
	{code: "4722", description: "Travel Agencies and Tour Operators"},
	{code: "4723", description: "TUI Travel - Germany"},
	{code: "4784", description: "Tolls and Bridge Fees"},
	{code: "4789", description: "Transportation Services - Not Elsewhere Classified"},
	{code: "4812", description: "Telecommunication Equipment and Telephone Sales"},
	{code: "4814", description: "Telecommunication Services"},
	{code: "4816", description: "Computer Network/Information Services"},
	{code: "4821", description: "Telegraph Services"},
	{code: "4829", description: "Wire Transfers and Money Orders"},
	{code: "4899", description: "Cable, Satellite, and Other Pay Television and Radio Services"},
	{code: "4900", description: "Utilities - Electric, Gas, Sanitary, Water"},
	{code: "5013", description: "Motor Vehicle Supplies and New Parts"},
	{code: "5021", description: "Office and Commercial Furniture"},
	{code: "5039", description: "Construction Materials - Not Elsewhere Classified"},
	{code: "5044", description: "Photographic, Photocopy, Microfilm Equipment and Supplies"},
	{code: "5045", description: "Computers and Computer Peripheral Equipment and Software"},
	{code: "5046", description: "Commercial Equipment - Not Elsewhere Classified"},
	{code: "5047", description: "Dental/Laboratory/Medical/Ophthalmic Hospital Equipment and Supplies"},
	{code: "5051", description: "Metal Service Centers and Offices"},
	{code: "5065", description: "Electrical Parts and Equipment"},
	{code: "5072", description: "Hardware Equipment and Supplies"},
	{code: "5074", description: "Plumbing and Heating Equipment and Supplies"},
	{code: "5085", description: "Industrial Supplies - Not Elsewhere Classified"},
	{code: "5094", description: "Precious Stones and Metals, Watches and Jewelry"},
	{code: "5099", description: "Durable Goods - Not Elsewhere Classified"},
	{code: "5111", description: "Stationery, Office Supplies, Printing and Writing Paper"},
	{code: "5122", description: "Drugs, Drug Proprietaries, and Druggist Sundries"},
	{code: "5131", description: "Piece Goods, Notions, and Other Dry Goods"},
	{code: "5137", description: "Men's, Women's, and Children's Uniforms and Commercial Clothing"},
	{code: "5139", description: "Commercial Footwear"},
	{code: "5169", description: "Chemicals and Allied Products - Not Elsewhere Classified"},
	{code: "5172", description: "Petroleum and Petroleum Products"},
	{code: "5192", description: "Books, Periodicals, and Newspapers"},
	{code: "5193", description: "Florist Supplies, Nursery Stock, and Flowers"},
	{code: "5198", description: "Paints, Varnishes, and Supplies"},
	{code: "5199", description: "Non-Durable Goods - Not Elsewhere Classified"},
	{code: "5200", description: "Home Supply Warehouse Stores"},
	{code: "5211", description: "Lumber and Building Materials Stores"},
	{code: "5231", description: "Glass, Paint, and Wallpaper Stores"},
	{code: "5251", description: "Hardware Stores"},
	{code: "5261", description: "Lawn and Garden Supply Stores"},
	{code: "5271", description: "Mobile Home Dealers"},
	{code: "5300", description: "Wholesale Clubs"},
	{code: "5309", description: "Duty-Free Stores"},
	{code: "5310", description: "Discount Stores"},
	{code: "5311", description: "Department Stores"},
	{code: "5331", description: "Variety Stores"},
	{code: "5399", description: "Miscellaneous General Merchandise"},
	{code: "5411", description: "Grocery Stores and Supermarkets"},
	{code: "5422", description: "Freezer and Locker Meat Provisioners"},
	{code: "5441", description: "Candy, Nut, and Confectionery Stores"},
	{code: "5451", description: "Dairy Products Stores"},
	{code: "5462", description: "Bakeries"},
	{code: "5499", description: "Miscellaneous Food Stores"},
	{code: "5511", description: "Car and Truck Dealers (New and Used) Sales, Service, Repairs, Parts and Leasing"},
	{code: "5521", description: "Car and Truck Dealers (Used Only) Sales, Service, Repairs, Parts and Leasing"},
	{code: "5531", description: "Auto and Home Supply Stores"},
	{code: "5532", description: "Automotive Tire Stores"},
	{code: "5533", description: "Automotive Parts and Accessories Stores"},
	{code: "5541", description: "Service Stations"},
	{code: "5542", description: "Automated Fuel Dispensers"},
	{code: "5551", description: "Boat Dealers"},
	{code: "5561", description: "Camper, Recreational and Utility Trailer Dealers"},
	{code: "5571", description: "Motorcycle Shops and Dealers"},
	{code: "5592", description: "Motor Home Dealers"},
	{code: "5598", description: "Snowmobile Dealers"},
	{code: "5599", description: "Miscellaneous Automotive, Aircraft, and Farm Equipment Dealers"},
	{code: "5611", description: "Men's and Boy's Clothing and Accessories Stores"},
	{code: "5621", description: "Women's Ready-to-Wear Stores"},
	{code: "5631", description: "Women's Accessory and Specialty Shops"},
	{code: "5641", description: "Children's and Infant's Wear Stores"},
	{code: "5651", description: "Family Clothing Stores"},
	{code: "5655", description: "Sports and Riding Apparel Stores"},
	{code: "5661", description: "Shoe Stores"},
	{code: "5681", description: "Furriers and Fur Shops"},
	{code: "5691", description: "Men's and Women's Clothing Stores"},
	{code: "5697", description: "Tailors, Seamstresses, Mending and Alterations"},
	{code: "5698", description: "Wig and Toupee Stores"},
	{code: "5699", description: "Miscellaneous Apparel and Accessory Shops"},
	{code: "5712", description: "Furniture, Home Furnishings and Equipment Stores"},
	{code: "5713", description: "Floor Covering Stores"},
	{code: "5714", description: "Drapery, Window Covering, and Upholstery Stores"},
	{code: "5718", description: "Fireplace, Fireplace Screens, and Accessories Stores"},
	{code: "5719", description: "Miscellaneous Home Furnishing Specialty Stores"},
	{code: "5722", description: "Household Appliance Stores"},
	{code: "5732", description: "Electronics Stores"},
	{code: "5733", description: "Music Stores - Musical Instruments, Pianos, and Sheet Music"},
	{code: "5734", description: "Computer Software Stores"},
	{code: "5735", description: "Record Stores"},
	{code: "5811", description: "Caterers"},
	{code: "5812", description: "Eating Places and Restaurants"},
	{code: "5813", description: "Drinking Places - Bars, Taverns, Nightclubs, Cocktail Lounges, and Discotheques"},
	{code: "5814", description: "Fast Food Restaurants"},
	{code: "5912", description: "Drug Stores and Pharmacies"},
	{code: "5921", description: "Package Stores - Beer, Wine, and Liquor"},
	{code: "5931", description: "Used Merchandise and Secondhand Stores"},
	{code: "5932", description: "Antique Shops - Sales, Repairs, and Restoration Services"},
	{code: "5933", description: "Pawn Shops"},
	{code: "5935", description: "Wrecking and Salvage Yards"},
	{code: "5937", description: "Antique Reproductions"},
	{code: "5940", description: "Bicycle Shops - Sales and Service"},
	{code: "5941", description: "Sporting Goods Stores"},
	{code: "5942", description: "Book Stores"},
	{code: "5943", description: "Stationery Stores, Office and School Supply Stores"},
	{code: "5944", description: "Jewelry Stores, Watches, Clocks, and Silverware Stores"},
	{code: "5945", description: "Hobby, Toy, and Game Shops"},
	{code: "5946", description: "Camera and Photographic Supply Stores"},
	{code: "5947", description: "Gift, Card, Novelty, and Souvenir Shops"},
	{code: "5948", description: "Luggage and Leather Goods Stores"},
	{code: "5949", description: "Sewing, Needlework, Fabric, and Piece Goods Stores"},
	{code: "5950", description: "Glassware and Crystal Stores"},
	{code: "5960", description: "Direct Marketing - Insurance Services"},
	{code: "5962", description: "Direct Marketing - Travel-Related Arrangement Services"},
	{code: "5963", description: "Door-to-Door Sales"},
	{code: "5964", description: "Direct Marketing - Catalog Merchants"},
	{code: "5965", description: "Direct Marketing - Combination Catalog and Retail Merchants"},
	{code: "5966", description: "Direct Marketing - Outbound Telemarketing Merchants"},
	{code: "5967", description: "Direct Marketing - Inbound Teleservices Merchants"},
	{code: "5968", description: "Direct Marketing - Continuity/Subscription Merchants"},
	{code: "5969", description: "Direct Marketing - Other Direct Marketers"},
	{code: "5970", description: "Artist Supply and Craft Shops"},
	{code: "5971", description: "Art Dealers and Galleries"},
	{code: "5972", description: "Stamp and Coin Stores"},
	{code: "5973", description: "Religious Goods Stores"},
	{code: "5975", description: "Hearing Aids - Sales, Service, and Supplies"},
	{code: "5976", description: "Orthopedic Goods - Prosthetic Devices"},
	{code: "5977", description: "Cosmetic Stores"},
	{code: "5978", description: "Typewriter Stores - Sales, Rentals, and Service"},
	{code: "5983", description: "Fuel Dealers - Fuel Oil, Wood, Coal, and Liquefied Petroleum"},
	{code: "5992", description: "Florists"},
	{code: "5993", description: "Cigar Stores and Stands"},
	{code: "5994", description: "News Dealers and Newsstands"},
	{code: "5995", description: "Pet Shops, Pet Food, and Supplies"},
	{code: "5996", description: "Swimming Pools - Sales, Service, and Supplies"},
	{code: "5997", description: "Electric Razor Stores - Sales and Service"},
	{code: "5998", description: "Tent and Awning Shops"},
	{code: "5999", description: "Miscellaneous Specialty Retail"},
	{code: "6010", description: "Financial Institutions - Manual Cash Disbursements"},
	{code: "6011", description: "Financial Institutions - Automated Cash Disbursements"},
	{code: "6012", description: "Financial Institutions - Merchandise, Services"},
	{code: "6051", description: "Non-Financial Institutions - Foreign Currency, Money Orders, Stored Value Card"},
	{code: "6211", description: "Securities - Brokers and Dealers"},
	{code: "6300", description: "Insurance Sales, Underwriting, and Premiums"},
	{code: "6381", description: "Insurance Premiums"},
	{code: "6399", description: "Insurance - Not Elsewhere Classified"},
	{code: "6513", description: "Real Estate Agents and Managers - Rentals"},
	{code: "7011", description: "Lodging - Hotels, Motels, and Resorts"},
	{code: "7012", description: "Timeshares"},
	{code: "7032", description: "Sporting and Recreational Camps"},
	{code: "7033", description: "Trailer Parks and Campgrounds"},
	{code: "7210", description: "Laundry, Cleaning, and Garment Services"},
	{code: "7211", description: "Laundry Services - Family and Commercial"},
	{code: "7216", description: "Dry Cleaners"},
	{code: "7217", description: "Carpet and Upholstery Cleaning"},
	{code: "7221", description: "Photographic Studios"},
	{code: "7230", description: "Barber and Beauty Shops"},
	{code: "7251", description: "Shoe Repair Shops, Shoe Shine Parlors, and Hat Cleaning Shops"},
	{code: "7261", description: "Funeral Services and Crematories"},
	{code: "7273", description: "Dating and Escort Services"},
	{code: "7276", description: "Tax Preparation Services"},
	{code: "7277", description: "Counseling Services - Debt, Marriage, and Personal"},
	{code: "7278", description: "Buying and Shopping Services and Clubs"},
	{code: "7296", description: "Clothing Rentals - Costumes, Uniforms, Formal Wear"},
	{code: "7297", description: "Massage Parlors"},
	{code: "7298", description: "Health and Beauty Spas"},
	{code: "7299", description: "Miscellaneous Personal Services - Not Elsewhere Classified"},
	{code: "7311", description: "Advertising Services"},
	{code: "7321", description: "Consumer Credit Reporting Agencies"},
	{code: "7332", description: "Blueprinting and Photocopying Services"},
	{code: "7333", description: "Commercial Photography, Art, and Graphics"},
	{code: "7338", description: "Quick Copy, Reproduction, and Blueprinting Services"},
	{code: "7339", description: "Stenographic and Secretarial Support Services"},
	{code: "7342", description: "Exterminating and Disinfecting Services"},
	{code: "7349", description: "Cleaning, Maintenance, and Janitorial Services"},
	{code: "7361", description: "Employment Agencies and Temporary Help Services"},
	{code: "7372", description: "Computer Programming, Data Processing, and Integrated Systems Design Services"},
	{code: "7375", description: "Information Retrieval Services"},
	{code: "7379", description: "Computer Maintenance and Repair Services - Not Elsewhere Classified"},
	{code: "7392", description: "Management, Consulting, and Public Relations Services"},
	{code: "7393", description: "Detective Agencies, Protective Agencies, and Security Services"},
	{code: "7394", description: "Equipment, Tool, Furniture, and Appliance Rentals and Leasing"},
	{code: "7395", description: "Photofinishing Laboratories and Photo Developing"},
	{code: "7399", description: "Business Services - Not Elsewhere Classified"},
	{code: "7511", description: "Truck Stop"},
	{code: "7512", description: "Automobile Rental Agency"},
	{code: "7513", description: "Truck and Utility Trailer Rentals"},
	{code: "7519", description: "Motor Home and Recreational Vehicle Rentals"},
	{code: "7523", description: "Parking Lots and Garages"},
	{code: "7531", description: "Automotive Body Repair Shops"},
	{code: "7534", description: "Tire Retreading and Repair Shops"},
	{code: "7535", description: "Automotive Paint Shops"},
	{code: "7538", description: "Automotive Service Shops (Non-Dealer)"},
	{code: "7542", description: "Car Washes"},
	{code: "7549", description: "Towing Services"},
	{code: "7622", description: "Electronics Repair Shops"},
	{code: "7623", description: "Air Conditioning and Refrigeration Repair Shops"},
	{code: "7629", description: "Electrical and Small Appliance Repair Shops"},
	{code: "7631", description: "Watch, Clock, and Jewelry Repair"},
	{code: "7641", description: "Furniture - Reupholstery, Repair, and Refinishing"},
	{code: "7692", description: "Welding Services"},
	{code: "7699", description: "Miscellaneous Repair Shops and Related Services"},
	{code: "7800", description: "Government-Owned Lotteries"},
	{code: "7801", description: "Government-Licensed On-Line Casinos (Online Gambling)"},
	{code: "7802", description: "Government-Licensed Horse/Dog Racing"},
	{code: "7829", description: "Motion Picture and Video Tape Production and Distribution"},
	{code: "7832", description: "Motion Picture Theaters"},
	{code: "7841", description: "Video Tape Rentals"},
	{code: "7911", description: "Dance Halls, Studios, and Schools"},
	{code: "7922", description: "Theatrical Producers (Except Motion Pictures) and Ticket Agencies"},
	{code: "7929", description: "Bands, Orchestras, and Miscellaneous Entertainers"},
	{code: "7932", description: "Billiard and Pool Establishments"},
	{code: "7933", description: "Bowling Alleys"},
	{code: "7941", description: "Commercial Sports, Professional Sports Clubs, Athletic Fields, and Sports Promoters"},
	{code: "7991", description: "Tourist Attractions and Exhibits"},
	{code: "7992", description: "Public Golf Courses"},
	{code: "7993", description: "Video Amusement Game Supplies"},
	{code: "7994", description: "Video Game Arcades and Establishments"},
	{
		code: "7995",
		description: "Betting, Casino Gambling, Lottery Tickets, Casino Gaming Chips, Off-Track Betting, and Wagers",
	},
	{code: "7996", description: "Amusement Parks, Circuses, Carnivals, and Fortune Tellers"},
	{
		code: "7997",
		description: "Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses",
	},
	{code: "7998", description: "Aquariums, Seaquariums, Dolphinariums, and Zoos"},
	{code: "7999", description: "Recreation Services - Not Elsewhere Classified"},
	{code: "8011", description: "Doctors - Not Elsewhere Classified"},
	{code: "8021", description: "Dentists and Orthodontists"},
	{code: "8031", description: "Osteopaths"},
	{code: "8041", description: "Chiropractors"},
	{code: "8042", description: "Optometrists and Ophthalmologists"},
	{code: "8043", description: "Opticians, Optical Goods, and Eyeglasses"},
	{code: "8049", description: "Podiatrists and Chiropodists"},
	{code: "8050", description: "Nursing and Personal Care Facilities"},
	{code: "8062", description: "Hospitals"},
	{code: "8071", description: "Medical and Dental Laboratories"},
	{code: "8099", description: "Medical Services and Health Practitioners - Not Elsewhere Classified"},
	{code: "8111", description: "Legal Services and Attorneys"},
	{code: "8211", description: "Elementary and Secondary Schools"},
	{code: "8220", description: "Colleges, Universities, Professional Schools, and Junior Colleges"},
	{code: "8241", description: "Correspondence Schools"},
	{code: "8244", description: "Business and Secretarial Schools"},
	{code: "8249", description: "Trade and Vocational Schools"},
	{code: "8299", description: "Schools and Educational Services - Not Elsewhere Classified"},
	{code: "8351", description: "Child Care Services"},
	{code: "8398", description: "Charitable and Social Service Organizations"},
	{code: "8641", description: "Civic, Social, and Fraternal Associations"},
	{code: "8651", description: "Political Organizations"},
	{code: "8661", description: "Religious Organizations"},
	{code: "8675", description: "Automobile Associations"},
	{code: "8699", description: "Membership Organizations - Not Elsewhere Classified"},
	{code: "8734", description: "Testing Laboratories (Non-Medical)"},
	{code: "8911", description: "Architectural, Engineering, and Surveying Services"},
	{code: "8931", description: "Accounting, Auditing, and Bookkeeping Services"},
	{code: "8999", description: "Professional Services - Not Elsewhere Classified"},
	{code: "9211", description: "Court Costs, Including Alimony and Child Support"},
	{code: "9222", description: "Fines"},
	{code: "9223", description: "Bail and Bond Payments"},
	{code: "9311", description: "Tax Payments"},
	{code: "9399", description: "Government Services - Not Elsewhere Classified"},
	{code: "9402", description: "Postal Services - Government Only"},
	{code: "9405", description: "Intra-Government Transactions"},
]
